<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary">
  <div class="inside-navigation">
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="/" title="GBWhatPro" rel="home">
          <img class="header-image is-logo-image" alt="GB WhatsApp Pro" src="@/assets/gbwa-logo.webp">
        </a>
      </div>
      <p class="main-title">
        <a href="/" rel="home">GBWhatPro</a>
      </p>
    </div>

    <ul
      v-if="$global.isMobileDevice()"
      class="menu sf-menu mobile-menu-page"
      v-show="isMenuClicked"
    >
      <li v-for="item in primaryNav" :key="'m-' + item.path" class="menu-item">
        <a :href="item.path" :class="{ 'download-btn': item.highlight }" @click="closeMenus">{{ item.label }}</a>
      </li>
      <li class="menu-item nav-guides-dropdown" :class="{ open: guidesOpen }">
        <span>Guides <span class="nav-guides-dropdown__arrow" @click.stop.prevent="guidesOpen = !guidesOpen">▼</span></span>
        <ul class="nav-guides-dropdown__menu">
          <li v-for="g in guidesNav" :key="g.path"><a :href="g.path" @click="closeMenus">{{ g.label }}</a></li>
        </ul>
      </li>
      <li v-for="item in secondaryNav" :key="'m2-' + item.path" class="menu-item">
        <a :href="item.path" @click="closeMenus">{{ item.label }}</a>
      </li>
    </ul>

    <div id="primary-menu" class="main-nav">
      <div class="mobile-menu" v-if="$global.isMobileDevice()">
        <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
          <img src="@/assets/menu.svg" alt="Open menu" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="Close menu" v-else>
        </div>
      </div>
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li v-for="item in primaryNav" :key="item.path" class="menu-item" :class="{ 'header-download': item.highlight }">
          <a :href="item.path" :class="{ 'download-btn': item.highlight }">{{ item.label }}</a>
        </li>
        <li class="menu-item nav-guides-dropdown" :class="{ open: guidesOpen }">
          <span>Guides <span class="nav-guides-dropdown__arrow" @click.stop.prevent="guidesOpen = !guidesOpen">▼</span></span>
          <ul class="nav-guides-dropdown__menu">
            <li v-for="g in guidesNav" :key="g.path"><a :href="g.path">{{ g.label }}</a></li>
          </ul>
        </li>
        <li v-for="item in secondaryNav" :key="'s-' + item.path" class="menu-item">
          <a :href="item.path">{{ item.label }}</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
import { primaryNav, guidesNav, secondaryNav } from '@/data/siteNav'

export default {
  props: {
    selectedLanguage: { type: String, default: 'en' },
    page: { type: String, default: 'home' },
    gotodownload: { type: Function },
    apk: { type: [String, Object] },
  },
  data() {
    return {
      primaryNav,
      guidesNav,
      secondaryNav,
      guidesOpen: false,
      isMenuClicked: false,
    }
  },
  methods: {
    closeMenus() {
      this.guidesOpen = false
      this.isMenuClicked = false
    },
  },
}
</script>

<style lang="scss" scoped>
#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    box-sizing: border-box;
    width: 100%;
    max-width: var(--content-max, 1120px);
    padding-left: var(--content-pad, 24px);
    padding-right: var(--content-pad, 24px);
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;
    li a,
    li span {
      font-weight: 500 !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .inside-navigation .mobile-menu-page {
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 1001;
    margin: 0 !important;

    .menu-item {
      padding: 14px 0;
      margin-bottom: 0 !important;
      background: #fff;
      text-align: center;

      a, span {
        font-size: 15px;
        color: #121212;
        display: block;
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu .menu-toggle {
      display: flex;
      justify-content: center;
      padding: 12px;

      img {
        width: 23px;
        height: 23px;
      }
    }
  }
}
</style>
